import TextField from "@mui/material/TextField";

import WebService from "../util/webService";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { getRandomInt, printVariable, searchSchool } from "../util/helper";
import {
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  Menu,
  Typography,
} from "@mui/material";
import useDelegate from "@hooks/useDelegate";
import { Fragment, useEffect, useMemo, useRef, useState, forwardRef, useImperativeHandle  } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FlatButton from "@components/FlatButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "@mui/styles";
import Select from "@mui/material/Select";
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator";
import useAlert from '@hooks/useAlert'
import useSnackbar from '@hooks/useSnackbar';
import Dialog from '@mui/material/Dialog';
import ConfirmDialog from "@components/ConfirmDialog";
import { detectBrowser } from "@util/helper";
import { creatreSvgStamp, createCanvasStamp, createCanvasSignature } from "@util/signature-stamp";
import { urlAlphabet } from "nanoid";
import Signer from '@components/Signer'

// export default function TestPage() {
function TestPage2() {
  const [stamp, set_stamp] = useState(null)
  const [png, set_png] = useState(null);
  const [png2, set_png2] = useState(null);

  const handleGenerate = async () => {
    await document.fonts.load("16px 'HakgyoansimNamu'");
    const svgBlob = new Blob([stamp], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const pngUrl = canvas.toDataURL('image/png');
        set_png(pngUrl);
        URL.revokeObjectURL(url);
      };
    img.src = url;
  };

  const options = {
              // fontPaths: ['../fonts/EliceDXNeolli-Medium.ttf'],
              width: 200,
              height:70,
            }

  return(
    <>
      <div>
        <Button
          onClick={() => {
            
            const svg = creatreSvgStamp('홍길동', 'NanumPen', options)
            console.log('svg=>', svg)
            set_stamp(svg)
          }}
        >도장생성</Button>
      </div>
      {/* <div>
          {
            stamp ? (
              <>
                <img
                  src={`data:image/svg+xml;utf8,${encodeURIComponent(stamp)}`}
                  alt="stamp"
                />
                <div
                  dangerouslySetInnerHTML={{ __html: stamp }}
                />
              </>
            ) : null
          }
      </div> */}
      <div>
        {stamp && (
          <Button
            onClick={async () => {
              const pngUrl = await createCanvasSignature('김강인', 'KCCKimHun', options)
              set_png(pngUrl)

              const pngUrl2 = await createCanvasSignature('김강인', 'KCCKimhwanki', options)
              set_png2(pngUrl2)
            }}
          >
            PNG 변환
          </Button>
        )}
        <div style={{ marginTop: 20 }}>
          {stamp && (
            <div>
              <div>stamp 미리보기(dangerouslySetInnerHTML):</div>
              <div
                dangerouslySetInnerHTML={{ __html: stamp }}
              />
              <div>
                <div>stamp 미리보기(img 태그):</div>
                 <img
                  src={`data:image/svg+xml;utf8,${encodeURIComponent(stamp)}`}
                  alt="stamp"
                />
              </div>
            </div>
            
            
          )}

          {png && (
            <div style={{ marginTop: 20 }}>
              <div>PNG 미리보기:</div>
              <img src={png} alt="stamp png" />
              <img src={png2} alt="stamp png" />
            </div>
          )}
        </div>
      </div>
      
    </>
    
  )    
}

export default function TestPage() {
  return (
    <Signer userName={'홍길동인이다'}/>
  )
}